export default __webpack_public_path__ + "static/Genuine Accessories – Vertical 400x400-1427707730235982068939f9bf4b36ca.svg";